/* @flow */
import cx from 'classnames';
import { capitalize } from 'lodash';
import * as React from 'react';

import Image from 'components/Image';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import SchoolEngagementBadge from 'schools/components/SchoolEngagementBadge';

import type { EngagementRating } from 'schools/constants/EngagementRatings';

import './SchoolEngagementBanner.scss';

type Props = {
  badgeAction: () => void,
  children: string,
  cta: string,
  eventKey: string,
  rating?: EngagementRating,
  theme?: 'dark' | 'light',
  to: string,
};

export default function SchoolEngagementBanner({
  badgeAction,
  children,
  cta,
  eventKey,
  rating,
  theme,
  to,
}: Props) {
  return (
    <div className={cx('SchoolEngagementBanner', theme && `SchoolEngagementBanner--${theme}`)}>
      <MediaObject center>
        {rating ? (
          <SchoolEngagementBadge rating={rating} size="small" onClick={badgeAction} />
        ) : (
          <Image src={require('assets/images/schools/SchoolEngagementBanner/light-bulb.svg')} />
        )}
        <Text align="left" element="div" size="small">
          <Row size="xsmall">
            <Text element="h3" uppercase weight="bold">
              {rating ? `Tip for schools rated ${capitalize(rating)}` : 'Tip'}
            </Text>
          </Row>
          <Text element="p" size="small">
            {children}
          </Text>
          <Link href={to} target="_blank" weight="semibold" eventKey={eventKey}>
            {cta}
          </Link>
        </Text>
      </MediaObject>
    </div>
  );
}

SchoolEngagementBanner.defaultProps = {
  theme: 'light',
};
